import React from 'react';
import { useQuery } from '@apollo/client';
import styled from 'styled-components';
import { Payment } from './Payment';
import { LinkContained } from './form/LinkContained';
import { respondToMin, respondToMax } from '../styled/rwd';
import { GET_PAYMENTS } from '../graphql/queries';

interface Props {
    order: string[];
    locale: string;
}

export type Item = {
    id: string;
    heading: string;
    subheading: string;
    descriptionHTML: string;
    price: number;
    url: string;
    label: string;
};

const Container = styled.div`
	${respondToMax('md')} {
		--content-gap: 24px;
	}

	${respondToMin('lg')} {
		--content-gap: 48px;
	}

	display: grid;
	grid-gap: var(--content-gap);
	justify-content: center;
	grid-template-columns: repeat(auto-fit, minmax(336px, 336px));
`;

const Item = styled.div<{ $borderColor: string; }>`
    display: grid;
    grid-template-rows: auto 1fr auto;
    border: 1px solid ${({ $borderColor }) => $borderColor};
`;

const Header = styled.header<{ $bgColor: string; }>`
    padding: 8px;
    color: #fff;
	text-align: center;
    background-color: ${({ $bgColor }) => $bgColor};
`;

const Heading = styled.h3`
	margin: 0;
    text-transform: uppercase;
`;

const Subheading = styled.h4`
	margin: 0;
`;

const Price = styled.div<{ $color: string; }>`
    margin: 8px 0 24px;
    color: ${({ $color }) => $color};
	${({ theme }) => theme.getTypography('h4')};
    text-align: center;
`;

const Body = styled.div`
	box-sizing: border-box;
	margin: var(--body-margin);
	padding: 24px;
    ${({ theme }) => theme.typography.richtext};
    ${({ theme }) => theme.ticks};
`;

const BuyButton = styled(LinkContained)`
    justify-self: center;
	display: block;
	min-width: 64px;
    margin-bottom: 16px;
`;

const headerColors = ['#3B8F7B', '#174654', '#50bea4'];

export const Payments = ({ order, locale }: Props) => {
    const { data, loading } = useQuery(GET_PAYMENTS, { variables: { order, locale } });

    return loading
        ? <div>loading</div>
        : <Container data-testid="payments">
            {data.payments.map((item: Item, i: number) =>
                <Payment
                    key={item.id}
                    {...item}
                    color={headerColors[i]}
                />)}
        </Container>
}